module.exports = __webpack_public_path__ + "img/arrow2.72a038c0.svg";